import React, { useEffect, useState } from "react";
import axiosClient from "../../axios-client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

const AllIndustries = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchReports = async () => {
      try {
        const response = await axiosClient.get("/reports/getReport");
        // Extract only the category field from the response
        const categories = response.data.map((report) => report.category);
        // Remove duplicates
        const uniqueCategories = [...new Set(categories)];
        setCategories(uniqueCategories);
      } catch (error) {
        console.error("Error fetching reports:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchReports();
  }, []);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredCategories = categories.filter((category) =>
    category.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div
      className="min-h-screen p-6"
      style={{ maxWidth: "91rem", backgroundColor: "#F0F9FF" }}
    >
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl md:text-2xl font-semibold">All Industries</h2>
        <div className="relative">
          <input
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={handleSearchChange}
            className="p-2 border border-gray-300 rounded-md pl-10"
          />
          <FontAwesomeIcon
            icon={faSearch}
            style={{ color: "#000000" }}
            className="absolute left-3 top-1/2 transform -translate-y-1/2"
          />
        </div>
      </div>
      <hr />
      {loading ? (
        <div className="flex justify-center items-center">
          <img src="/images/loading.gif" alt="Loading..." />
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
          {filteredCategories.map((category, index) => (
            <div
              key={index}
              className="bg-[#f33f7d] rounded-lg shadow-lg p-2 sm:p-4 md:p-6 transition-all duration-500 ease-in-out hover:scale-105 hover:bg-white flex items-center justify-center"
              style={{ padding: "0.5rem" }}
            >
              <p className="text-sm sm:text-lg font-semibold mb-1 sm:mb-2 text-center">
                {category}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AllIndustries;
